<template>
  <div class="card-legend-wrap">
    <span v-if="icon" class="card-legend-icon" aria-hidden="true">{{
      icon
    }}</span>
    <span class="card-legend">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'FormLegend',
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.card-legend-wrap {
  position: absolute;
  top: -11px;
  left: 22px;
  padding: 4px 10px 3px;
  border-radius: 999px;
  background: #fafaf7;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.card-legend-icon {
  font-size: 10px;
  color: #66705f;
  opacity: 0.9;
}

.card-legend {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5b6323;
}
</style>
